<template>
  <div class="tsny_nav" :style="cssProps">
    <b-row class="pt-5 mb-3">
      <b-col>
        <b-nav vertical v-b-scrollspy="scrollSpyConfig">
          <slot :scroll-into-view="scrollIntoView" />
        </b-nav>
      </b-col>
    </b-row>
    <b-row v-if="submitEvent">
      <b-col>
        <b-button class="tsny_button nav_button" @click="submit"
          >SUBMIT</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Utilities from "../services/Utilities";
import EventBus from "../services/eventBus/EventBus";

export default {
  name: "NavMenu",
  props: {
    submitEvent: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: "#191919"
    },
    offset: {
      type: Number,
      default: 300
    }
  },
  computed: {
    cssProps() {
      return {
        "--text-color": this.color === "#191919" ? "191919" : "white",
        "--button-color": this.color === "#191919" ? "#f8f8f8" : this.color,
        "--background-color": this.color
      };
    }
  },
  data() {
    return {
      scrollSpyConfig: {
        offset: this.offset
      }
    };
  },
  methods: {
    scrollIntoView(id) {
      const navElement = document.querySelector(`#${id}`);
      if (navElement) {
        document.scrollingElement.scrollTop = Utilities.offsetTop(navElement);
      }
    },
    submit() {
      EventBus.$emit(this.submitEvent);
    }
  }
};
</script>

<style scoped lang="scss">
$text-color: var(--text-color);
$button-color: var(--button-color);
$background-color: var(--background-color);

.tsny_nav {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
}

.nav_button {
  width: 100%;
  color: $text-color;
  background: $button-color;
  font-size: x-large;
}

.nav_button:hover {
  background: $button-color;
  filter: brightness(85%);
}

.active {
  font-weight: bold;
}

a.active::after {
  content: "";
  width: 0.6em;
  height: 1em;
  background: var(--background-color);
  display: inline-block;
  vertical-align: middle;
}
</style>
